<template>
  <div>
    <v-dialog v-model="LoaderDialogVisible" persistent width="300">
      <v-card color="#008230" dark>
        <v-card-text>
          Por favor espere...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "LoaderDialog",
  computed: {
    ...mapState(["LoaderDialogVisible"])
  }
};
</script>

<style>
</style>